module.exports = __webpack_public_path__ + "static/oris-1c55b5cc199194eccadef15b69698904.png";